import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
    MatCheckboxChange,
    MatCheckboxModule
} from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { TranslocoModule } from '@jsverse/transloco';
import { ProviderSite } from '../../models/provider.model';

@Component({
    selector: 'app-provider-site-selector',
    templateUrl: './provider-site-selector.component.html',
    styleUrls: ['./provider-site-selector.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatListModule,
        TranslocoModule
    ]
})
export class ProviderSiteSelectorComponent {
    @Input() sites: ProviderSite[] = [];
    @Input() showTitle = true;
    @Input() set selectedSiteIds(value: number[] | undefined) {
        this._selectedSiteIds = value ?? [];
    }
    get selectedSiteIds(): number[] {
        return this._selectedSiteIds;
    }
    private _selectedSiteIds: number[] = [];
    @Output() selectedSiteIdsChange = new EventEmitter<number[]>();

    selectSite(event: MatCheckboxChange): void {
        const updatedIds = [...this.selectedSiteIds];
        const siteId = Number(event.source.value);
        const indexOfSelection = updatedIds.indexOf(siteId);

        if (event.source.checked) {
            if (indexOfSelection === -1) {
                updatedIds.push(siteId);
            }
        } else {
            if (indexOfSelection !== -1) {
                updatedIds.splice(indexOfSelection, 1);
            }
        }

        this.selectedSiteIdsChange.emit(updatedIds);
    }
}
